import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "image", "empty", "cancel", "error", "status"]
  static values = { originalUrl: String }

  connect() {
    if (this.inputTarget.files.length) this.change()
  }

  disconnect() {
    this.releasePreview()
  }

  change() {
    const file = this.inputTarget.files[0]
    this.resetFeedback()
    this.releasePreview()
    this.showPreview(this.originalUrlValue)
    this.cancelTarget.hidden = !file
    if (!file) return

    const error = !["image/jpeg", "image/png", "image/webp"].includes(file.type)
      ? "Selecione uma imagem PNG, JPG ou WebP."
      : file.size > 2 * 1024 * 1024 ? "A imagem deve ter no máximo 2 MB." : null

    this.statusTarget.textContent = file.name
    if (error) {
      this.errorTarget.textContent = error
      this.errorTarget.hidden = false
      this.inputTarget.setCustomValidity(error)
      this.inputTarget.setAttribute("aria-invalid", "true")
      return
    }

    this.previewUrl = URL.createObjectURL(file)
    this.showPreview(this.previewUrl)
  }

  cancel() {
    this.inputTarget.value = ""
    this.change()
    this.statusTarget.textContent = this.originalUrlValue ? "Capa atual mantida." : "Seleção da foto cancelada."
    this.inputTarget.focus()
  }

  showPreview(url) {
    if (url) this.imageTarget.src = url
    else this.imageTarget.removeAttribute("src")
    this.previewTarget.hidden = !url
    this.emptyTarget.hidden = Boolean(url)
  }

  resetFeedback() {
    this.inputTarget.setCustomValidity("")
    this.inputTarget.removeAttribute("aria-invalid")
    this.errorTarget.hidden = true
    this.errorTarget.textContent = ""
    this.statusTarget.textContent = ""
  }

  releasePreview() {
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl)
    this.previewUrl = null
  }
}
